namespace Portico.Models.Enterprise {

    export interface IPharmacy {
		id: string;
        type: string;
        name: string;
        nabp: string;
        npi: string;
		specialization: string;

        addresses: Address[];
		contacts: Contact[];
        emailAddresses: EmailAddress[];
        phoneNumbers: PhoneNumber[];
        webAddresses: WebAddress[];  

		addAddress(index?: number): Address;
		addContact(index?: number): Contact;
		addEmailAddress(index?: number): EmailAddress;
		addPhoneNumber(index?: number): PhoneNumber;
		addWebAddress(index?: number): WebAddress;
    }

    export class Pharmacy implements IPharmacy {
		id: string;
        type: string;
        name: string;
        nabp: string;
        npi: string;
		specialization: string;

        addresses: Address[];
		contacts: Contact[];
        emailAddresses: EmailAddress[];
        phoneNumbers: PhoneNumber[];
        webAddresses: WebAddress[];

        constructor(obj?: IPharmacy | any) {
            this.id = null;
            this.type = null;
            this.name = '';
            this.nabp = '';
            this.npi = '';
			this.specialization = '';

            this.addresses = [];
            this.contacts = [];
            this.emailAddresses = [];
            this.phoneNumbers = [];
            this.webAddresses = [];

            if (obj) {
                this.id = obj.id || obj.pharmacyId || null;
				this.type = obj.type || obj.pharmacyType || null;
                this.name = obj.name || obj.pharmacyName || '';
				this.nabp = obj.nabp || '';
				this.npi = obj.npi || '';
				this.specialization = obj.specialization || obj.pharmacySpecialization || '';

                if (obj.addresses) {
                    for (const address of obj.addresses) {
                        this.addresses.push(new Address(address));
                    }
                }

				if (obj.contacts) {
                    for (const contact of obj.contacts) {
                        this.contacts.push(new Contact(contact));
                    }
				}

                if (obj.emailAddresses) {
                    for (const emailAddress of obj.emailAddresses) {
                        this.emailAddresses.push(new EmailAddress(emailAddress));
                    }
                }

                if (obj.phoneNumbers) {
                    for (const phoneNumber of obj.phoneNumbers) {
                        this.phoneNumbers.push(new PhoneNumber(phoneNumber));
                    }
                }

				if (obj.webAddresses) {
					for (const webAddress of obj.webAddresses) {
						this.webAddresses.push(new WebAddress(webAddress));
					}
				}
            }
        }

		addAddress(index: number = null): Address {
			const length = this.addresses.length;

			if (index && index < length) {
				return this.addresses[index];
			}

			const address = new Address();
			this.addresses.push(address);
			return address;
		}

		addContact(index: number = null): Contact {
			const length = this.contacts.length;

			if (index && index < length) {
				return this.contacts[index];
			}

			const contact = new Contact();
			this.contacts.push(contact);
			return contact;
		}

		addEmailAddress(index: number = null): EmailAddress {
			const length = this.emailAddresses.length;

			if (index && index < length) {
				return this.emailAddresses[index];
			}

			const emailAddress = new EmailAddress();
			this.emailAddresses.push(emailAddress);
			return emailAddress;
		}

		addPhoneNumber(index: number = null): PhoneNumber {
			const length = this.phoneNumbers.length;

			if (index && index < length) {
				return this.phoneNumbers[index];
			}

			const phoneNumber = new PhoneNumber();
			this.phoneNumbers.push(phoneNumber);
			return phoneNumber;
		}

		addWebAddress(index: number = null): WebAddress {
			const length = this.webAddresses.length;

			if (index && index < length) {
				return this.webAddresses[index];
			}

			const webAddress = new WebAddress();
			this.webAddresses.push(webAddress);
			return webAddress;
		}
    }
}
